import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class GCKCodeService extends CrudService {
  constructor() {
    super('gckCodes')
  }

  uploadGCKCode = async (file) => {
    const form = new FormData()
    form.append('file', file)

    const response = await axios.post(`${this.resource}/upload`, form)

    return response.data
  }
}

export default GCKCodeService
